/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const FARVER = { ingen: '#ef4444', afventer: '#f59e0b', modtaget: '#22c55e' };
const LABELS  = { ingen: 'Ingen', afventer: 'Afventer', modtaget: 'Modtaget' };

export default function FuldmagtCompliancePanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hent = () =>
      fetch('/api/os/sags-diagnostik/fuldmagt', { credentials: 'include' })
        .then(r => r.json())
        .then(setData)
        .catch(console.error)
        .finally(() => setLoading(false));
    hent();
    const interval = setInterval(hent, 300000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div style={{ color: '#94a3b8', padding: 32 }}>Henter fuldmagt-data...</div>;
  if (!data)   return <div style={{ color: '#ef4444', padding: 32 }}>Fejl ved hentning</div>;

  const pieData = (data.fordeling || []).map(f => ({
    name: LABELS[f.fuldmagt_status] || f.fuldmagt_status || 'Ukendt',
    value: parseInt(f.antal) || 0,
    farve: FARVER[f.fuldmagt_status] || '#6b7280',
    status: f.fuldmagt_status,
  }));
  const total         = pieData.reduce((s, d) => s + d.value, 0);
  const modtaget      = pieData.find(d => d.status === 'modtaget')?.value || 0;
  const compliancePct = total > 0 ? Math.round((modtaget / total) * 100) : 0;

  return (
    <div>
      <div style={{ display: 'flex', gap: 24, marginBottom: 32, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 250 }}>
          <div style={{ display: 'flex', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
            <div style={{
              background: '#0f172a', borderRadius: 12, padding: '16px 24px',
              border: `1px solid ${compliancePct > 50 ? '#22c55e' : '#ef4444'}33`, flex: 1,
            }}>
              <div style={{ fontSize: 11, color: '#94a3b8' }}>Compliance-rate</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: compliancePct > 50 ? '#22c55e' : '#ef4444' }}>
                {compliancePct}%
              </div>
            </div>
            {data.udloeber_30d > 0 && (
              <div style={{
                background: '#0f172a', borderRadius: 12, padding: '16px 24px',
                border: '1px solid #f59e0b33', flex: 1,
              }}>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>Udloeber inden for 30d</div>
                <div style={{ fontSize: 36, fontWeight: 700, color: '#f59e0b' }}>{data.udloeber_30d}</div>
              </div>
            )}
          </div>

          <div style={{ height: 180 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} dataKey="value">
                  {pieData.map((d, i) => <Cell key={i} fill={d.farve} />)}
                </Pie>
                <Tooltip
                  contentStyle={{ background: '#1e293b', border: 'none', borderRadius: 8, color: '#e2e8f0' }}
                  formatter={(v, n) => [v + ' klienter', n]}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            {pieData.map(d => (
              <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', background: d.farve }} />
                <span style={{ color: '#94a3b8', fontSize: 12 }}>{d.name}: {d.value}</span>
              </div>
            ))}
          </div>
        </div>

        {(data.mangler_fuldmagt || []).length > 0 && (
          <div style={{ flex: 2, minWidth: 280 }}>
            <div style={{ color: '#ef4444', fontWeight: 600, marginBottom: 12, fontSize: 13 }}>
              Aktive sager uden gyldig fuldmagt ({(data.mangler_fuldmagt || []).length})
            </div>
            <div style={{ maxHeight: 300, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
              {(data.mangler_fuldmagt || []).map(k => (
                <div key={k.id} style={{
                  background: '#0f172a', borderRadius: 8, padding: '8px 12px',
                  display: 'flex', justifyContent: 'space-between',
                }}>
                  <span style={{ color: '#e2e8f0', fontSize: 13 }}>{k.fornavn} {k.efternavn}</span>
                  <span style={{
                    color: '#ef4444', fontSize: 12,
                    background: '#ef444422', padding: '2px 8px', borderRadius: 4,
                  }}>
                    {k.fuldmagt_status || 'ingen'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
